export const PricingAreaOne = () => {
  return (
    <section className="pricing-area">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-8 col-lg-8">
            <div className="section-title text-center mb-60 tg-heading-subheading animation-style2">
              <span className="sub-title tg-element-title"></span>
              <h2 className="title tg-element-title">Industries We Support</h2>
              <p>
                Kadle Global Pvt Ltd serves diverse industries including
                agriculture, construction, energy and technology-driven
                enterprises, providing integrated solutions designed to
                streamline operations and advance sustainability.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
